import { render, staticRenderFns } from "./SingleSignon.vue?vue&type=template&id=6c199b24&"
import script from "./SingleSignon.vue?vue&type=script&lang=ts&"
export * from "./SingleSignon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports